import { Box, Drawer, Portal } from "@chakra-ui/react";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { SideMenu } from "./SideMenu";

export const HamburgerMenu = ({ setMobileOpen }) => {
  const [open, setOpen] = useState(false);

  return (
    <Drawer.Root open={open} size="xs" onOpenChange={(e) => setOpen(e.open)} placement="start">
      <Drawer.Trigger asChild>
        <Box
          as="button"
          type="button"
          aria-label="Open menu"
          display="flex"
          p={2}
          borderRadius="md"
          border="1px solid"
          borderColor="border.subtle"
          color="fg.muted"
          cursor="pointer"
          _hover={{ bg: "gray.50" }}
          onClick={() => setOpen(true)}
        >
          <Menu size={18} />
        </Box>
      </Drawer.Trigger>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content maxW="272px">
            <Drawer.Body p={0} position="relative">
              <Box
                as="button"
                type="button"
                aria-label="Close menu"
                position="absolute"
                top="18px"
                right="12px"
                zIndex={1}
                display="flex"
                p={1.5}
                borderRadius="md"
                color="fg.subtle"
                cursor="pointer"
                _hover={{ bg: "gray.100" }}
                onClick={() => setOpen(false)}
              >
                <X size={18} />
              </Box>
              <SideMenu
                isCollapsed={false}
                setCollapsed={() => {}}
                isMobileOpen={open}
                setMobileOpen={setOpen}
              />
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};
